import Component from './component';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Home/index.js